<template>
  <div class="enrolling-student-giveup" v-loading="submitting" element-loading-text="数据提交中...">
    <div class="title">
      <span>请输入放弃原因：</span>
    </div>
    <div class="form">
      <el-input type="textarea" v-model="giveUpReason" maxlength="200" clearable/>
    </div>
    <div class="button">
      <el-button type="primary" @click="submit">提交保存</el-button>
      <el-button @click="closePop">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrollingStudentGiveUp',
  props: {
    cellValue: String
  },
  data () {
    return {
      submitting: false,
      giveUpReason: null
    }
  },
  methods: {
    submit () {
      this.submitting = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/setGiveUpStatus',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.cellValue,
          code: '1',
          giveUpReason: this.giveUpReason
        })
      }).then((response) => {
        if (response.data && response.data.responseCode === 'SUCCESS') {
          this.$message.success('提交成功')
          this.closePop()
        } else {
          this.$message.error('提交失败')
        }
      }).finally(() => {
        this.submitting = false
      })
    },
    closePop () {
      this.$emit('hidePopoverAndRefresh')
    }
  }
}
</script>

<style lang="scss">
.enrolling-student-giveup {
  padding: 20px;
  .title {
    height: 40px;
  }
  .form {
    padding: 10px 0;
  }
  .button {
    text-align: center;
    height: 30px;
  }
}
</style>
